// extracted by mini-css-extract-plugin
export default {"container":"layout_container__T+lEo","main":"layout_main__NS9px"};